// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const FormWrapper = styled.form`
  padding: 1em;

  display: -ms-grid;
  -ms-grid-columns: (1fr 1em)[4] auto;
  -ms-grid-rows: auto 1em auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "errors-list errors-list  errors-list   errors-list errors-list errors-list"
    "asr-number asr-latitude asr-longitude search-radius asr-lookup-search fa";
  grid-template-columns: repeat(4, 1fr) auto;
  grid-template-rows: auto auto;

  /* comes from <SubmitErrors /> */
  > .errors-list-wrapper {
    grid-area: errors-list;
    -ms-grid-column: 1;
    -ms-grid-column-span: 9;
    -ms-grid-row: 1;
  }

  > .asr-number {
    grid-area: asr-number;
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }

  > .asr-latitude {
    grid-area: asr-latitude;
    -ms-grid-column: 3;
    -ms-grid-row: 3;
  }

  > .asr-longitude {
    grid-area: asr-longitude;
    -ms-grid-column: 5;
    -ms-grid-row: 3;
  }

  > .search-radius {
    grid-area: search-radius;
    -ms-grid-column: 7;
    -ms-grid-row: 3;
  }

  > .asr-lookup-search {
    grid-area: asr-lookup-search;
    -ms-grid-column: 9;
    -ms-grid-row: 3;

    // allows for horizontal alignment wth the input fields.
    margin-top: .95em;
  }

  > .fa {
    grid-area: fa;
    -ms-grid-column: 11;
    -ms-grid-row: 3;

    // allows for horizontal alignment wth the input fields.
    margin-top: .95em;
    margin-right: 1em;
  }
`
